import React, {useEffect} from 'react';
import { Button, Intent, Tooltip } from '@blueprintjs/core';
import DataSyncList from './components/DataSyncList';
import { useHistory } from 'react-router-dom';
import MainContainer from './MainContainer';
import { directoryStore } from '../../stores/DirectoryStore';
import { DataSyncStore, dataSyncStore } from '../../stores/DataSyncStore';
import { showToasts } from '../../lib/toaster';
import { useObserver } from 'mobx-react';

export const DataSyncListPage = () => {
  const history = useHistory();

  const fetchDataSyncs = async () => {
    try {
      if (directoryStore.trackerId) {
        return await dataSyncStore.fetch();
      }
    } catch (e) {
      showToasts([{intent: 'danger', message: `Failed to fetch data syncs. ${e}`}]);
    }
  };

  useEffect(() => {
    fetchDataSyncs();
  }, []);

  const headerActions = useObserver(() => (
    <>
      <Button
        text="Refresh"
        intent={Intent.NONE}
        onClick={async () => {
          await fetchDataSyncs();
        }}
      />
      <Tooltip
        content={`Maximum number of data syncs is ${DataSyncStore.MAX_DATA_SYNCS}. Please delete existing syncs before creating a new one.`}
        disabled={dataSyncStore.dataSyncCount < DataSyncStore.MAX_DATA_SYNCS}
        placement="bottom"
      >
        <Button
          disabled={dataSyncStore.dataSyncCount >= DataSyncStore.MAX_DATA_SYNCS}
          intent={Intent.PRIMARY}
          text="New Sync"
          onClick={() => history.push('/data_syncs/new')}
        />
      </Tooltip>
    </>
  ));

  return (
    <MainContainer headerActions={headerActions} fixedHeight={true}>
      <DataSyncList dataSyncStore={dataSyncStore} />
    </MainContainer>
  );
};
